export default "__VITE_ASSET__CfGNPg1b__"